<template>
  <div>
    <!-- <v-header>
      <form class="search" v-if="$route.meta.useSearch" @submit.prevent="searchSubmit">
        <el-input v-model="search" placeholder="请输入课程名搜索">
          <el-button native-type="submit" slot="append">搜索</el-button>
        </el-input>
      </form>
    </v-header>

    <v-nav :list="list"></v-nav> -->

    <TopNav/>

    <transition>
      <router-view></router-view>
    </transition>

    <v-footer></v-footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Nav from '@/components/Navigation'
import Footer from '@/components/Footer'
import TopNav from '@/components/topNav'

import event from '@/util/event'

export default {
  name: 'App',

  components: {
    'v-header': Header,
    'v-nav' : Nav,
    'v-footer': Footer,
    TopNav
  },

  data() {
    return {
      search: '',
      list: []
    }
  },

  computed: {
  },

  created() {
    this.init()
  },

  methods: {
    init() {
      if (this.$route.name === 'login-main'
        || this.$route.name === 'register-main') {
        this.list = []
        return
      }

      const role = this.$route.params.role
      if (role === 'user') {
        this.list = [
          { name: '首页', path: '/' },
          { name: '个人中心', path: `/${role}/home` },
          { name: '课程库', path: `/${role}/manage` },
          { name: '有问有答', path: `/${role}/ask` }
        ]
      } else if (role === 'admin') {
        this.list = [
          { name: '首页', path: '/' },
          { name: '员工管理', path: `/${role}/saff` },
          { name: '课程管理', path: `/${role}/manage` },
          { name: '订购管理', path: `/${role}/setting` },

        ]
      }
    },

    searchSubmit() {
      const keyword = (this.search || '').trim()
      event.$emit('headerSearchChange', { keyword })
    }
  },

  watch: {
    '$route': function(to) {
      this.init()
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../assets/style/colors";

.search {
  position: relative;
  top: 5px;
  float: right;
  .el-input {
    width: 360px;
    /deep/ input:focus {
      border-color: #e8e8e8;
    }
  }
  button {
    width: 88px;
    border-radius: 0;
    background: #f9af4e;
    border-color: #f9af4e;
    color: #fff;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to  {
  opacity: 0;
}

// bounce(动画)
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout.vue